import { Typography } from '@mui/material';

const ErrorText = ({ children, marginTop = 0 }) => (
  <div
    translate="no"
    style={{ minHeight: '1.5rem', display: 'flex', alignItems: 'center' }}
  >
    <Typography style={{ color: 'red', fontSize: '0.875rem', marginTop }}>
      {children}
    </Typography>
  </div>
);

export default ErrorText;
